import { IPrivateEndpointMetadata } from './private-endpoint-metadata';
import { getReadonlyControl, getManualResourceIdControl } from './shared-control-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { azureResourceSelectMethodOptions } from '../consts/metadata-consts';

const akvResourceId = '/subscriptions/<subscriptionID>/resourceGroups/<resourceGroupName>/providers/Microsoft.KeyVault/vaults/<resourceName>';
const akvResourceIdFormat = '\/?subscriptions\/.+\/resourceGroups\/.+\/providers\/Microsoft.KeyVault\/vaults\/.+';
const akvResourceIdErrorMessage = format(stringResources.InvalidResourceId, akvResourceId);

export const azureKeyVaultPrivateEndpointMetadata: IPrivateEndpointMetadata = {
    resourceType: 'Microsoft.KeyVault/vaults',
    connectionSuffix: 'networking',
    resourceIdValidator: akvResourceIdFormat,
    groupIdMetadata: {
        vault: {
            linkedServiceType: adfModelTypeMap.azureKeyVault.linkedServiceType,
            groupId: 'vault',
            iconClass: 'svg-i-100x100-azure_key_vault',
            displayName: stringResources.AzureKeyVault_DisplayText,
            controls: {
                creationControls: [{
                    type: 'radio-switch',
                    nested: 1,
                    label: stringResources.AzureKeyVault_AccountName_SelectionMethod,
                    description: stringResources.AzureKeyVault_AccountName_SelectionMethod_Description,
                    options: azureResourceSelectMethodOptions,
                    isLabelVertical: true,
                    defaultValue: '{privateLinkResourceId != null ? "manual" : "azure"}',
                    cases: [
                        {
                            caseValue: 'azure',
                            children: [
                                {
                                    type: 'azure-key-vault-select',
                                    bind: {
                                        resourceID: 'privateLinkResourceId'
                                    },
                                    showEditButton: false,
                                    validators: {
                                        resourceID: [
                                            { type: 'required', errorMessage: '' }
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            caseValue: 'manual',
                            children: [
                                getManualResourceIdControl(
                                    format(stringResources.PrivateEndpointResourceIdPlaceholder, akvResourceId),
                                    akvResourceIdFormat,
                                    akvResourceIdErrorMessage)
                            ]
                        }
                    ]
                }],
                readonlyControls: getReadonlyControl(akvResourceIdFormat, akvResourceIdErrorMessage)
            }
        }
    }
};
